<template>
  <footer class="footer-transparent hide-768 absolute down">
    <div>
      <span class="font-tiny font-gray-two">© {{new Date().getFullYear()}} Union poisťovňa, a. s.</span>
    </div>
    <div>
      <a target="_blank" href="https://www.union.sk/union-o-poistovni" class="font-tiny font-gray-two mr-1">Insurance Provider Information</a>
      <a target="_blank" href="https://www.union.sk/ochrana-osobnych-udajov" class="font-tiny font-gray-two">Personal Data Protection</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'TransparentFooter',
};
</script>
